module.exports = __webpack_public_path__ + "static/media/molinera_chamizal.30f2f2d5.png";